import * as React from 'react';
import { motion } from 'motion/react';

const animations = {
    expanded: {
        height: 'auto',
        overflow: 'auto',
        transition: {
            ease: 'easeOut',
            duration: 0.2
        }
    },
    collapsed: {
        height: '0px',
        overflow: 'hidden',
        transition: {
            ease: 'easeIn',
            duration: 0.2
        }
    }
};
const Expander = ({ isExpanded , children  })=>/*#__PURE__*/ React.createElement(motion.div, {
        initial: animations.collapsed,
        animate: isExpanded ? animations.expanded : animations.collapsed,
        "aria-hidden": !isExpanded,
        className: "configurator-footer-expander"
    }, children)
;

export { Expander };
//# sourceMappingURL=Expander.js.map
